import { qualityCheckActionTypes } from '@Actions/quality/qualityCheckActions';

const QualityCheckReducers = (state = { }, action) => {
  switch (action.type) {
  case qualityCheckActionTypes.GET_QUALITY_CHECKS.LOADING: {
    const { qualityChecksLoading } = action;
    return {
      ...state,
      qualityChecksLoading,
    };
  }
  case qualityCheckActionTypes.GET_QUALITY_CHECKS.SUCCESS: {
    const { qualityChecks } = action;
    return {
      ...state,
      qualityChecks,
    };
  }
  case qualityCheckActionTypes.GET_QUALITY_CHECK_BY_ID.LOADING: {
    const { getQualityCheckByIdLoading } = action;
    return {
      ...state,
      getQualityCheckByIdLoading,
    };
  }
  case qualityCheckActionTypes.GET_QUALITY_CHECK_BY_ID.SUCCESS: {
    const { selectedQualityCheck } = action;
    return {
      ...state,
      selectedQualityCheck,
    };
  }
  case qualityCheckActionTypes.GET_DOWNLOAD_QUALITY_CHECK.LOADING: {
    const { getDownloadQualityChecksLoading } = action;
    return {
      ...state,
      getDownloadQualityChecksLoading,
    };
  }
  case qualityCheckActionTypes.CREATE_QUALITY_CHECK.LOADING: {
    const { createQualityCheckLoading } = action;
    return {
      ...state,
      createQualityCheckLoading,
    };
  }
  case qualityCheckActionTypes.UPDATE_QUALITY_CHECK.LOADING: {
    const { updateQualityCheckLoading } = action;
    return {
      ...state,
      updateQualityCheckLoading,
    };
  }
  case qualityCheckActionTypes.DELETE_QUALITY_CHECK.LOADING: {
    const { deleteQualityCheckLoading } = action;
    return {
      ...state,
      deleteQualityCheckLoading,
    };
  }
  case qualityCheckActionTypes.GET_QUALITY_CHECK_REPORT.LOADING: {
    const { getQualityCheckReportLoading } = action;
    return {
      ...state,
      getQualityCheckReportLoading,
    };
  }
  case qualityCheckActionTypes.PUT_QC_ON_HOLD.LOADING: {
    const { putQualityCheckOnHoldLoading } = action;
    return {
      ...state,
      putQualityCheckOnHoldLoading,
    };
  }
  case qualityCheckActionTypes.UPDATE_QC_ASSIGNEES.LOADING: {
    const { updateQualityCheckAssigneeLoading } = action;
    return {
      ...state,
      updateQualityCheckAssigneeLoading,
    };
  }
  default: {
    return state;
  }
  }
};

export default QualityCheckReducers;
